/**
 * Input Schema of MotoristaCancelamentoCarga
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {MotoristaCancelamentoCarga} from '@/model/resource/MotoristaCancelamentoCarga'
import {CargaCollection} from '@/model/collection/CargaCollection'
import {MotoristaCollection} from '@/model/collection/MotoristaCollection'

/* TODO: review generated schema */
export class InputMotoristaCancelamentoCargaSchema extends Schema {
  collectionCarga = new CargaCollection().noPagination()
  collectionMotorista = new MotoristaCollection().noPagination()

  readonly name = 'InputMotoristaCancelamentoCarga'

  readonly fieldSet: FieldSet<MotoristaCancelamentoCarga> = {
    carga: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionCarga.all(),
      },
    }),
    motorista: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionMotorista.all(),
      },
    }),
    data: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'datetime',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
